import '../css/app.scss';
import Swiper from 'swiper/bundle';

const headerMobmenu = document.querySelector('.header__bottom-burger');
const headerCloseMobmenu = document.querySelector('.header__bottom-close');
const header = document.querySelector('.header__bottom-list-inner');
const body = document.querySelector('body');

if (headerMobmenu !== null && headerCloseMobmenu !== null) {
    headerMobmenu.addEventListener('click', () => {
        header.classList.add('open');
        body.classList.add('body-overflow');
    })

    headerCloseMobmenu.addEventListener('click', () => {
        header.classList.remove('open');
        body.classList.remove('body-overflow');
    })
};

function addArrowToMobMenu() {
    if (window.innerWidth < 1200) {
        const hasChildrenMenu = document.querySelectorAll('.header__bottom-list .menu-item-has-children');

        hasChildrenMenu.forEach((itemMenu) => {
            if (!itemMenu.querySelector('.header__submenu-arrow')) {
                let toggle = document.createElement('span');
                toggle.classList.add('header__submenu-arrow');

                const link = itemMenu.querySelector('a');
                if (link) {
                    link.insertAdjacentElement('afterend', toggle);
                }

                const subMenu = itemMenu.querySelector('.sub-menu');
                if (subMenu) {
                    toggle.addEventListener('click', (e) => {
                        e.preventDefault();
                        itemMenu.classList.toggle('open');
                        itemMenu.classList.toggle('active');
                        if (itemMenu.classList.contains('open')) {
                            subMenu.style.maxHeight = subMenu.scrollHeight + 'px';
                        } else {
                            subMenu.style.maxHeight = 0;
                        }
                    });
                }
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    addArrowToMobMenu();
});

window.addEventListener('resize', () => {
    addArrowToMobMenu();
});

const blockNewsSlider = new Swiper(".block-news__slider", {
    slidesPerView: 3,
    spaceBetween: 30,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        320: {
            slidesPerView: 1,
            spaceBetween: 30,
        },
        992: {
            slidesPerView: 2,
            spaceBetween: 30,
        },
        1200: {
            slidesPerView: 3,
        },
    },
});

const blockKnowledgeBaseSlider = new Swiper(".block-knowledge-base__slider", {
    slidesPerView: 3,
    spaceBetween: 30,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        320: {
            slidesPerView: 1,
            spaceBetween: 30,
        },
        992: {
            slidesPerView: 2,
            spaceBetween: 30,
        },
        1200: {
            slidesPerView: 3,
        },
    },
});

const homeTopSlider = new Swiper(".home-top__slider", {
    loop: true,
    speed: 2000,
    autoplay: {
        delay: 3000,
        disableOnInteraction: false,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    pagination: {
        el: ".swiper-pagination",
    },
});

window.addEventListener('DOMContentLoaded', () => {

    const resizableSwiper = (breakpoint, swiperClass, swiperSettings, callback) => {
        let swiper;

        breakpoint = window.matchMedia(breakpoint);

        const enableSwiper = function(className, settings) {
            swiper = new Swiper(className, settings);

            if (callback) {
                callback(swiper);
            }
        }

        const checker = function() {
            if (breakpoint.matches) {
                return enableSwiper(swiperClass, swiperSettings);
            } else {
                if (swiper !== undefined) swiper.destroy(true, true);
                return;
            }
        };

        breakpoint.addEventListener('change', checker);
        checker();
    }

    const someFunc = (instance) => {
        if (instance) {
            instance.on('slideChange', function (e) {});
        }
    };

    resizableSwiper(
        '(max-width: 1280px)',
        '.home-vendors__slider',
        {
            loop: true,
            spaceBetween: 32,
            slidesPerView: 4,
            autoplay: {
                delay: 1,
                disableOnInteraction: false,
            },
            speed: 8000,
            // allowTouchMove: false,
            breakpoints: {
                320: {
                    slidesPerView: 2,
                    spaceBetween: 0,
                    speed: 5000,
                },
                576: {
                    slidesPerView: 2,
                    spaceBetween: 40,
                },
                992: {
                    slidesPerView: 4,
                    spaceBetween: 40,
                    speed: 8000,
                },
            },
        },
        someFunc
    );
});

const pageAboutUsVendorsSlider = new Swiper(".page-about-us__vendors-slider", {
    loop: true,
    spaceBetween: 32,
    slidesPerView: 6,
    autoplay: {
        delay: 1,
        disableOnInteraction: false,
    },
    speed: 8000,
    breakpoints: {
        320: {
            slidesPerView: 3,
            spaceBetween: 0,
            speed: 5000,
        },
        576: {
            slidesPerView: 3,
            spaceBetween: 40,
        },
        768: {
            slidesPerView: 3,
            spaceBetween: 40,
        },
        992: {
            slidesPerView: 4,
            spaceBetween: 40,
            speed: 8000,
        },
        1200: {
            slidesPerView: 5,
        },
        1700: {
            slidesPerView: 7,
        },
    },
});